// NPM packages
import React from 'react';
import {
  FontAwesomeIcon,
} from '@fortawesome/react-fontawesome';
import {
  faCircle,
} from '@fortawesome/free-regular-svg-icons';
import { Typography } from '@mui/material';
import Link from 'components/core/Link';

export interface AdditionalResourceProps {
    url: string;
    name: string;
    description: string;
  }

function AdditionalResource(props: AdditionalResourceProps): React.ReactElement | null {

    const { url, name, description } = props;

    let body: React.ReactNode;

    body = (
        <div
            style={{
                display: 'flex',
                flexDirection: 'row',
                gap: '0.5rem',
            }}
        >
            <FontAwesomeIcon
                style={{
                    fontSize: '0.5rem',
                    marginTop: '0.625rem',
                }}
                icon={faCircle}
            />
            <Typography variant='body1'>
                <Link
                    style={{
                        whiteSpace: 'normal',
                        wordBreak: 'break-word',
                        overflowWrap: 'break-word',
                    }}
                    to={url}
                    openNewTab
                >
                    {name}
                </Link> - {description}
            </Typography>
        </div>
    )

    return body;
}

export default AdditionalResource;
